import React from 'react';
import { StanButton, StanInput } from '@/components';
import { getMFADescription, getMFATitle, MFAConfigSource } from '../../../constants/mfa';

interface MFANameMethodProps {
    source: MFAConfigSource;
    authenticatorName: string;
    onNameChange: (name: string) => void;
    onFinishSetup: () => void;
    isLoading?: boolean;
}

export const MFANameMethod: React.FC<MFANameMethodProps> = ({
    source,
    authenticatorName,
    onNameChange,
    onFinishSetup,
    isLoading = false,
}) => {
    const title = getMFATitle('name_configuration', source);
    const description = getMFADescription('name_configuration', source);

    const canFinish = authenticatorName.trim().length > 0;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (canFinish) {
            onFinishSetup();
        }
    };

    return (
        <div className='flex flex-col items-center text-center'>
            {/* Header */}
            <div className='mb-4 flex flex-col items-center'>
                <h3 className='mb-2'>{title}</h3>
                <p className='text-gray text-body-sm'>{description}</p>
            </div>

            {/* Name Input Form */}
            <form onSubmit={handleSubmit} className='mt-3 w-full'>
                <StanInput
                    name='authenticator-name'
                    placeholder='Authenticator app'
                    value={authenticatorName}
                    onChange={e => onNameChange(e.target.value)}
                    className='mb-4'
                />

                <StanButton
                    name='mfa-finish-setup-button'
                    type='submit'
                    className='w-full'
                    size='md'
                    disabled={!canFinish || isLoading}
                    loading={isLoading}
                >
                    Finish Setup
                </StanButton>
            </form>
        </div>
    );
};
